import Vue from 'vue';
import EventsList from "../../vue/EventsList";

new Vue({
    el: 'main',
    components: {
        'events-list': EventsList,
    },
});